module.exports = __webpack_public_path__ + "fa4817415426715415fee29d0f088d54.png";